import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const getFirstReturnForOrderInputSchema_ = z.object({ orderId: z.string() });

export const getFirstReturnForOrderInputSchema: z.ZodType<GetFirstReturnForOrderInput> =
  getFirstReturnForOrderInputSchema_;
export interface GetFirstReturnForOrderInput extends z.infer<
  typeof getFirstReturnForOrderInputSchema_
> {}

const getFirstReturnForOrderOutputSchema_ = z.object({
  returnId: zExt.objectId().optional(),
});

export const getFirstReturnForOrderOutputSchema: z.ZodType<GetFirstReturnForOrderOutput> =
  getFirstReturnForOrderOutputSchema_;
export interface GetFirstReturnForOrderOutput extends z.infer<
  typeof getFirstReturnForOrderOutputSchema_
> {}

export const getFirstReturnForOrder = {
  name: "getFirstReturnForOrder" as const,
  input: getFirstReturnForOrderInputSchema,
  output: getFirstReturnForOrderOutputSchema,
};
